import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { injectIntl } from 'react-intl'
import { Switch, Route } from 'react-router-dom'
import { Result } from 'antd'
import { connect } from 'react-redux'

import { getStores } from 'src/redux-store/actions/app-actions'
import { updateStoreId } from 'src/redux-store/actions/user-actions'

import Auth from '../Auth'
import Home from '../Home'
import Page404 from '../404'
import Header from 'src/components/Header'
import StoreModal from 'src/components/StoreModal'
import Footer from 'src/components/Footer'
import { WhiteLayout, PaddedContent } from 'src/common/styled'

const App = props => {
  const { intl, user, stores, getStores, updateStoreIdAction } = props
  const [isStoreModalVisible, setIsStoreModalVisible] = useState(false)

  const isEmptyUser = isEmpty(user)

  useEffect(() => {
    if (user.authorizations?.permissions?.isAdmin) {
      getStores()
      openStoreModal()
    }
  }, [isEmptyUser, user.authorizations?.permissions?.isAdmin, getStores])

  const updateStoreId = storeId => {
    updateStoreIdAction(storeId)
    closeStoreModal()
  }

  const openStoreModal = () => setIsStoreModalVisible(true)
  const closeStoreModal = () => setIsStoreModalVisible(false)

  const renderUserIsNotEnabled = () => {
    return (
      <Result
        status={'403'}
        title={intl.formatMessage({ id: 'app.user.isNotEnabled' })}
      />
    )
  }

  return (
    <WhiteLayout>
      <Header user={user} changeStore={openStoreModal} />
      <Auth>
        <PaddedContent>
          <Switch>
            {!user.authorizations?.permissions?.isBlinksUser ? (
              <Route render={() => renderUserIsNotEnabled()} />
            ) : null}
            <Route component={Home} exact path={'/'} />
            <Route component={Page404} />
          </Switch>
        </PaddedContent>
      </Auth>
      <StoreModal
        stores={stores}
        isVisible={isStoreModalVisible}
        onCloseModal={closeStoreModal}
        onSelectStore={updateStoreId}
      />
      <Footer />
    </WhiteLayout>
  )
}
App.propTypes = {
  user: PropTypes.object,
}

const mapStateToProps = state => ({
  user: state.user.current,
  stores: state.app.stores
})
const mapDispatchToProps = {
  getStores,
  updateStoreIdAction: updateStoreId
}
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(App))
